// @flow

import { VERTICAL_IDS } from '~/common/constants/common';
import homesQueryMapper from './homesQueryMapper';
import carsQueryMapper from './carsQueryMapper';
import jobsQueryMapper from './jobsQueryMapper';
import productsQueryMapper from './productsQueryMapper';

const verticalIdQueryMapperMap = {
  [VERTICAL_IDS.homes]: homesQueryMapper,
  [VERTICAL_IDS.cars]: carsQueryMapper,
  [VERTICAL_IDS.jobs]: jobsQueryMapper,
  [VERTICAL_IDS.products]: productsQueryMapper,
};

export default function getQueryMapperByVerticalId(verticalId: number) {
  return verticalIdQueryMapperMap[verticalId];
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/shared/SearchNotifications/adapters/subscriptionQueryMapper/getQueryMapperByVerticalId.js